import { AppAreaConfig } from '@/funnels/@types'

const appAreaConfig: AppAreaConfig = {
	appArea: 'activity-male-military-calisthenics-pr',
	options: {
		userTags: ['calisthenics'],
	},
	landing: {
		ids: ['loader-military-calisthenics-m', 'age-military-calisthenics-m-pr'],
		route: {
			path: '/military-calisthenics-m-pr',
			name: 'military-calisthenics-m-pr-funnel',
		},
	},
	funnel: {
		id: 'ob-male-military-calisthenics',
		route: {
			path: '/military-calisthenics-m-pr/ob/:page(.*)?',
			name: 'activity-male-military-calisthenics-pr',
		},
		slug: 'activity-male-military-calisthenics-pr',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl', 'ja'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-military-calisthenics-m-pr',
	},
	upsell: {
		routeNames: ['upsell-military-calisthenics-m'],
	},
}

export default appAreaConfig
